module.exports = __webpack_public_path__ + "static/media/Capri_logowS4C-v1.1.d08fd9c4.png";